import { Box, BoxProps, Breakpoint, Fade } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { useStyles } from '../../hooks';
import React from 'react';

interface Props extends BoxProps {
  open: boolean;
  children: React.ReactNode;
  fullWidth?: boolean;
  maxWidth?: Breakpoint;
  styles?: any
}

const CustomModal: React.FC<Props> = ({ open, children, fullWidth = true, maxWidth = 'sm', styles = {} }) => {
  const { isSmallScreen } = useStyles();
  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      aria-labelledby="responsive-dialog-title"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
            marginTop: isSmallScreen ? '80px' : 0,
            backgroundColor: (theme) => theme.palette.background.secondary,
            border: (theme) => `1px solid ${theme.palette.background.border}`,
            ...styles
          },
        },
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <Fade in={open}>
        <Box style={{ height: '100%' }} pb={5}>
          {children}
        </Box>
      </Fade>
    </Dialog>
  );
};

export default CustomModal;
